import { render } from "./index.vue?vue&type=template&id=3f851371"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\takeda\\ui\\takeda_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/module/tab/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f851371"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f851371', __exports__)) {
    console.log('reload')
    api.reload('3f851371', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3f851371", () => {
    console.log('re-render')
    api.rerender('3f851371', render)
  })

}


export default __exports__